import { React, useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import Admin from "../Admin/Admin.jsx";
import { hasAccess } from "../../utils/permissions.js";
import {  levelContentData } from "./LevelContentData.js";
import { transformLevelContent } from "../../utils/transformLevelContent.js";
import { mergedContent } from "../../utils/mergeContentByLevel.js";
import { videoTitle, docTitle, utilsTitle } from "../../utils/titles.js";
import { slugify } from "../../utils/slugify.js";
import "./LevelContent.css";
import plusImage from "../../images/checkbox-add.svg";
import { TreeNode } from "../MindMap/MindMap.jsx";
import "../MindMap/MindMap.css";
import { useTranslation } from "../../utils/hooks/translateHook.js"; // nav and general basic content 
import { useLevelContentData } from "../../utils/hooks/translateLevelContentDataHook.js";
import fundamentals from "./config.js";



const handleEditProfile = () => {
  // Navigate to edit profile page or open modal
  console.log("Edit profile clicked");
};

const handleChangePassword = () => {
  // Open change password modal
  console.log("Change password clicked");
};

const LevelContent = ({ user, setCurrentUser, isAdminPreview = false }) => {
  const { courseSlug } = useParams();
  const [openTreeIndex, setOpenTreeIndex] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [openSubjectIndex, setOpenSubIndex] = useState(null);
  const [selectedSubjectIdx, setSelectedSubjectIdx] = useState(null);
  const [selectedType, setSelectedType] = useState(null); // "Lessons" or "Documents"
  const coursePath = (path) => `/course/${courseSlug}${path}`;
  const t = useTranslation();

  const translatedData = useLevelContentData (
    fundamentals.levelContentData,
    fundamentals.slug
  )

  //const transformedData = transformLevelContent(levelContentData);
  //const allMerged = mergedContent(transformedData); // ✅ Use transformed version
  
  //const rawLevelContentData = useLevelContentData(); 
  const transformedData = transformLevelContent(translatedData);
  const allMerged = mergedContent(transformedData); // ✅ Use transformed version

  if (user.subscriptionLevel === 9999 && !isAdminPreview) return <Admin />;

  const userLevelContent = transformedData
    .slice()
    .sort((a, b) => b.level - a.level)
    .find((item) => hasAccess(user, item.level, courseSlug));

  const accessibleLevels = transformedData
    .filter((item) => hasAccess(user, item.level, courseSlug) && item.level !== 9999)
    .sort((a, b) => a.level - b.level);

  const allContentItems = accessibleLevels.flatMap((item) => item.contentItems || []);
  const uniqueItems = [...new Set(allContentItems)];

  const mergedForSelected = selectedLevel
    ? allMerged.find((item) => item.level === selectedLevel.level)
    : null;

  return (
    <div className="course-fundamental">
      <div className="content-section">
        <div className="content-layout">
          <div style={{width: '100%'}}>
            <div className="content-info">
              <div className="section-items">
                <div className="section-linksContainerRA">
                  <NavLink to={coursePath("/mycourses")} className="section-links">{t('courses')}</NavLink> |
                  <NavLink to={coursePath("/docs")} className="section-links">{t('ebooks')}</NavLink> |
                  <NavLink to={coursePath("/notes")} className="section-links">{t('notes')}</NavLink> | 
                  <NavLink to={coursePath("/account")} className="section-links">{t('account')}</NavLink>
                  {/* <NavLink to='/board' className="section-links">{t('myEducationBoard')}</NavLink> */}
                </div>
                <div className="section-headingContainer">
                  <p className="section-heading">{userLevelContent?.title}</p>
                  <span className="content-intro">
                    {userLevelContent?.description}{" "}
                    {/* Please visit<NavLink to="/dashboard" className="content-introNavLink"> <i className="dashboard">DashBoard</i> </NavLink>for reviewing full educational content of your package. */}
                  </span>
                </div>
                
                <div style={{ borderRadius: '20px' }} className="infoDiv">
                  <ul className="contentItems-list">
                    {uniqueItems.map((item, idx) => (
                      <li key={idx} className="contentItems-item">
                        {/* <img src={plusImage} alt="plus icon" className="plus-icon" /> */}
                        {item.toUpperCase()}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="content-card">
              <div className="map-container-wrapper row-layout">

                {/* Left: Mind Map Tree */}
                <div className="map-container">
                  {accessibleLevels.map((level, idx) => (
                    <div className="map-row" key={idx}>
                      <TreeNode
                        title={
                          <>
                            <img src={level.rank} alt={`Rank ${Array.isArray(level.title) ? level.title[0] : level.title}`} />
                            {Array.isArray(level.title) ? level.title[0] : level.title}
                          </>
                        }
                        subtitle=""
                        isFirst={idx === 0}
                        isOpen={openTreeIndex === idx}
                        onToggle={() => {
                          setOpenTreeIndex(openTreeIndex === idx ? null : idx);
                          setSelectedLevel(openTreeIndex === idx ? null : level);
                        }}
                        childrenNodes={[]}
                      />
                    </div>
                  ))}
                </div>
                {selectedLevel && mergedForSelected && (
                  <div className="map-content-panel">
                    <h3>{t(selectedLevel.title)}</h3>
                    <p >{t(selectedLevel.description)}</p>      

                    <div className="subject-content-wrapper">
                      {/* SUBJECT LIST (LEFT SIDE) */}
                      <div className="subject-column">
                        {mergedForSelected.subjects.map((subject, idx) => (
                          <div key={idx} className="subject-block">
                            <div
                              className={`subject-title ${selectedSubjectIdx === idx ? "active" : ""}`}
                              onClick={() => {
                                setSelectedSubjectIdx(idx);
                                setSelectedType(null); // Reset section
                              }}
                            >
                              {subject.title}
                            </div>

                            {selectedSubjectIdx === idx && (
                              <div className="subject-sections">
                                {subject.videos?.length > 0 && (
                                  <div
                                    className={`section-link ${selectedType === "Lessons" ? "selected" : ""}`}
                                    onClick={() => setSelectedType("Lessons")}
                                  >
                                    {t('lessons')}
                                  </div>
                                )}
                                {subject.docs?.length > 0 && (
                                  <div
                                    className={`section-link ${selectedType === "Documents" ? "selected" : ""}`}
                                    onClick={() => setSelectedType("Documents")}
                                  >
                                    {t('documents')}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>

                      {/* CONTENT PANEL (RIGHT SIDE) */}
                      <div className="content-column">
                        {selectedSubjectIdx !== null && selectedType && (
                          <div className="content-list">
                            {selectedType === "Lessons" &&
                              mergedForSelected.subjects[selectedSubjectIdx].videos?.map((video, i) => (
                                <div key={i}>
                                  <Link to={`/course/${courseSlug}/videos/${slugify(video)}`}>{videoTitle(video)}</Link>
                                </div>
                              ))}

                            {selectedType === "Documents" &&
                              mergedForSelected.subjects[selectedSubjectIdx].docs?.map((doc, i) => (
                                <div key={i}>
                                  <Link to={`/course/${courseSlug}/docs/${slugify(doc)}`}>{docTitle(doc)}</Link>
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                    {(() => {
                      const groupedUtils = {};

                      // From subject utils
                      mergedForSelected.subjects?.forEach(subject => {
                        if (subject.utils?.length > 0) {
                          const label = subject.fromTitle || "Other";
                          if (!groupedUtils[label]) groupedUtils[label] = [];
                          groupedUtils[label].push(...subject.utils);
                        }
                      });

                      // From flatUtils 
                      if (mergedForSelected.flatUtils?.length) {
                        groupedUtils["This Pack"] = [
                          ...(groupedUtils["This Pack"]|| []),
                          ...mergedForSelected.flatUtils
                        ]
                      }
                      const utilsEntries = Object.entries(groupedUtils).filter(([, utils]) => utils.length > 0);
                      if (utilsEntries.length === 0) return null;

                      return (
                        <details>
                          <summary className="section-utilsSubheading">
                            {t('utilities')} <span className="dropdown-icon" />
                          </summary>
                          <div className="map-utilities-panel">
                            {utilsEntries.map(([label, utils], idx) => (
                              <ul key={idx} className="map-utils-list">
                                {utils.map((filename, i) => (
                                  <li key={i}>
                                    <Link to={`/utils/${slugify(filename)}`}>{utilsTitle(filename)}</Link>
                                  </li>
                                ))}
                              </ul>
                            ))}
                          </div>
                        </details>
                      );
                    })()}

                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelContent;
